import * as React from "react"
import {history, WithModalStore} from "../App"
import {
  Auth0Config,
  Auth0ConfigFragFragment,
  Booker as BOOKER,
  BookerByNewBookerSecret,
  BookerFragFragment,
} from "../graphql/queries"
import {errorUnionToEither, handleError} from "../graphql/errors"
import {isReady, liftEitherInOption, loading, Loading, loadingIfNull} from "../tsutil"
import {Loader} from "semantic-ui-react"
import {auth0Url, redirectTo} from "./Auth0LockLink"
import {GraphQL} from "../graphql"

interface Props extends WithModalStore {
  newBookerSecret: string
  bookingNumber: string | null
}

interface AllProps extends Props {
  booker: Loading<BookerFragFragment | null>
  auth0Config: Loading<Auth0ConfigFragFragment>
  newBooker: Loading<BookerFragFragment | null>
}

interface LoadedProps extends Props {
  booker: BookerFragFragment | null
  auth0Config: Auth0ConfigFragFragment
  newBooker: BookerFragFragment | null
}

class NewBookerLoginLoaded extends React.Component<LoadedProps> {
  componentDidMount(): void {
    const {booker, newBooker, auth0Config, bookingNumber, newBookerSecret} = this.props
    if (booker) {
      // Once the booker is logged in, take them to the booking.
      history.push(bookingNumber === null ? "/bookings" : "/booking/" + bookingNumber)
    } else {
      // We should allow login because the person might already have an account in Auth0 from
      // the old database (site_user) but which hasn't been connected to a booker in our new
      // database.
      const allowLogin = true
      const allowSignUp = true
      if (newBooker) {
        // TODO We also have newBooker.name. We should prefill the signup form with that as well.
        const email = newBooker.email
        redirectTo(auth0Url(auth0Config, email, "signUp", allowLogin, allowSignUp, newBookerSecret))
      } else {
        // The fetch of the new booker might result in null, probably because this link has
        // already been used (which blanks out the new_booker_secret on the booker), but still
        // we take them to the login page where they can login and get redirected to the booking.
        redirectTo(auth0Url(auth0Config, null, "login", allowLogin, allowSignUp))
      }
    }
  }

  render() {
    return null
  }
}

function NewBookerLoginLoading(props: AllProps) {
  if (isReady(props.auth0Config) && isReady(props.booker) && isReady(props.newBooker)) {
    return (
      <NewBookerLoginLoaded
        {...props}
        auth0Config={props.auth0Config.value}
        booker={props.booker.value}
        newBooker={props.newBooker.value}
      />
    )
  } else {
    return <Loader active />
  }
}

function NewBookerLoginWithAuth0Config(props: AllProps) {
  return (
    <GraphQL.Query
      query={Auth0Config}
      variables={{}}
      render={({data}) => {
        return (
          <NewBookerLoginLoading
            {...props}
            auth0Config={loadingIfNull(data).map((x) => x.auth0Config)}
          />
        )
      }}
    />
  )
}

function NewBookerLoginWithBooker(props: AllProps) {
  return (
    <GraphQL.Query
      query={BOOKER}
      variables={{}}
      render={({data}) => {
        const booker = liftEitherInOption(
          loadingIfNull(data).map((x) => errorUnionToEither(x.booker)),
        )
        return handleError(booker, (booker) => (
          <NewBookerLoginWithAuth0Config {...props} booker={booker.map((x) => x.booker)} />
        ))
      }}
    />
  )
}

function NewBookerLoginWithNewBooker(props: AllProps) {
  return (
    <GraphQL.Query
      query={BookerByNewBookerSecret}
      variables={{secret: props.newBookerSecret}}
      render={({data}) => {
        return (
          <NewBookerLoginWithBooker
            {...props}
            newBooker={loadingIfNull(data).map((x) => x.bookerByNewBookerSecret)}
          />
        )
      }}
    />
  )
}

export function NewBookerLogin(props: Props) {
  return (
    <NewBookerLoginWithNewBooker
      {...props}
      booker={loading}
      auth0Config={loading}
      newBooker={loading}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/NewBookerLogin.tsx